
import { defineComponent, shallowRef } from 'vue'
import Pic from '@/components/Pic.vue'
import Icon from '@/components/Icon.vue'

export default defineComponent({
  name: 'TheDownloadEntry',
  components: {
    Pic,
    Icon,
  },
  setup () {
    const showDownload = shallowRef(false)

    const u = navigator.userAgent
    showDownload.value = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1

    const downloadApp = () => {
      window.location.href = 'market://details?id=com.wtmob.app'
    }

    return {
      showDownload,
      downloadApp,
    }
  },
})
